import { TipoAditivo, UsuarioPF, UsuarioPJ } from '@vabembarqueja/embarque-ja-shared-components';

import { SituacaoTour } from './Tour.model';

export enum TipoUsuario {
  PESSOA_FISICA = 1,
  PESSOA_JURIDICA = 2
}

export enum SolicitacaoState {
  NAO_SOLICITADO = 1,
  PENDENTE = 2,
  AVALIADO = 3,
  REPROVADO = 4
}

export enum TipoProcessoAnalise {
  Contrato = 0,
  Aditivo = 1
}

export interface PaymentMethods {
  mostrarCartaoCredito: boolean;
  mostrarCartaoDebito: boolean;
  mostrarBoleto: boolean;
  mostrarPix: boolean;
  usarYuno: boolean;
}

export interface FaseSolicitacao {
  nomeFase: string;
  ordemFase: number;
  dataCriacao: Date | null;
  dataResposta: Date | null;
  faseAprovada: boolean | null;
  statusFase: 'EmAnalise' | 'Aprovada' | 'Reprovada' | null;
  usuarioResposta: string | null;
  ressalva: boolean;
  observacao: string | null;
  tipoProcesso: TipoProcessoAnalise;
}
export interface UsuarioPosPagoState {
  posPagoAtivo: boolean;
  solicitacao: SolicitacaoState;
  dataParaNovoPedido: Date | null;
  fases: Array<FaseSolicitacao>;
  orgaoPublico: boolean;
  statusAditivo: TipoAditivo | null;
  paymentMethods: PaymentMethods;
}

export interface UsuarioIncompleto {
  nome: string;
  cpf: string;
  email: string;
}

export type UsuarioConta = (UsuarioPF | UsuarioPJ | UsuarioIncompleto) & {
  situacaoTour?: SituacaoTour | null;
};
